module.exports = __webpack_public_path__ + "7d282edd.svg";